/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';


import * as PaymentMethodsBanner from 'src/components/PaymentMethodsBanner';
import * as TextBanner from 'src/components/TextBanner';
import * as TextSpot from 'src/components/TextSpot';
import * as TopSection from 'src/components/TopSection';
import * as TopWarningMessage from 'src/components/TopWarningMessage';
import * as VideoBanner from 'src/components/VideoBanner';
import * as CategoryPromoSlider from 'src/components/CategoryPromo/CategoryPromoSlider';
import * as CategoryPromoSlides from 'src/components/CategoryPromo/CategoryPromoSlides';
import * as CategoryPromoSpot from 'src/components/CategoryPromo/CategoryPromoSpot';
import * as CategoryPromoSpotSliderButton from 'src/components/CategoryPromo/CategoryPromoSpotSliderButton';
import * as categoryPromoSpotTypes from 'src/components/CategoryPromo/categoryPromoSpotTypes';
import * as SimpleFormWrapper from 'src/components/Forms/SimpleFormWrapper';
import * as IconTiles from 'src/components/IconTiles/IconTiles';
import * as Breadcrumb from 'src/components/Layout/Footer/Breadcrumb/Breadcrumb';
import * as Footer from 'src/components/Layout/Footer/Footer/Footer';
import * as CondensedMenumodel from 'src/components/Layout/Header/CondensedMenu/CondensedMenu.model';
import * as CondensedMenu from 'src/components/Layout/Header/CondensedMenu/CondensedMenu';
import * as LanguageSelector from 'src/components/Layout/Header/LanguageSelector/LanguageSelector';
import * as Header from 'src/components/Layout/Header/MegaMenu/Header';
import * as Submenu from 'src/components/Layout/Header/MegaMenu/Submenu';
import * as types from 'src/components/Layout/Header/MegaMenu/types';
import * as Search from 'src/components/Layout/Search/Search';
import * as LinkBlock from 'src/components/LinkBlock/LinkBlock';
import * as SustainabilitySpot from 'src/components/Product/SustainabilitySpot';
import * as ANCTypes from 'src/components/Product/ANCTypes/ANCTypes';
import * as AccessorySpot from 'src/components/Product/AccessorySpot/AccessorySpot';
import * as SliderCardWithPrice from 'src/components/Product/AccessorySpot/SliderCardWithPrice';
import * as SliderWithPrice from 'src/components/Product/AccessorySpot/SliderWithPrice';
import * as BentoGrid from 'src/components/Product/BentoGrid/BentoGrid';
import * as AwardsSpot from 'src/components/Product/Buy/AwardsSpot/AwardsSpot';
import * as BoxContent from 'src/components/Product/Buy/BoxContent/BoxContent';
import * as EcomBenefits from 'src/components/Product/Buy/EcomBenefits/EcomBenefits';
import * as FAQSpot from 'src/components/Product/Buy/FAQ/FAQSpot';
import * as GlobalDealsRibbon from 'src/components/Product/Buy/GlobalDealsRibbon/GlobalDealsRibbon';
import * as HeroCustomizer from 'src/components/Product/Buy/HeroCustomizer/HeroCustomizer';
import * as Hotspots from 'src/components/Product/Buy/Hotspots/Hotspots';
import * as KSPSpot from 'src/components/Product/Buy/KSPSpot/KSPSpot';
import * as PillSlider from 'src/components/Product/Buy/PillSlider/PillSlider';
import * as SupportSpot from 'src/components/Product/Buy/Support/SupportSpot';
import * as TopBanner from 'src/components/Product/Buy/TopBanner/TopBanner';
import * as CompareTableColumn from 'src/components/Product/CompareTablesSpot/CompareTableColumn';
import * as CompareTablesSpot from 'src/components/Product/CompareTablesSpot/CompareTablesSpot';
import * as compareTableSpotTypes from 'src/components/Product/CompareTablesSpot/compareTableSpotTypes';
import * as ContentSliderSpot from 'src/components/Product/ContentSliderSpot/ContentSliderSpot';
import * as CustomerStorySpot from 'src/components/Product/CustomerStorySpot/CustomerStorySpot';
import * as DualColumnPromoItem from 'src/components/Product/DualColumnPromo/DualColumnPromoItem';
import * as DualColumnPromoSpot from 'src/components/Product/DualColumnPromo/DualColumnPromoSpot';
import * as dualColumnPromoTypes from 'src/components/Product/DualColumnPromo/dualColumnPromoTypes';
import * as EnterpriseBatterySpot from 'src/components/Product/EnterpriseBatterySpot/EnterpriseBatterySpot';
import * as EnterpriseGenericPromoSpot from 'src/components/Product/EnterpriseGenericPromoSpot/EnterpriseGenericPromoSpot';
import * as EnterpriseImageSpot from 'src/components/Product/EnterpriseImageSpot/EnterpriseImageSpot';
import * as GallerySliderSpot from 'src/components/Product/GallerySliderSpot/GallerySliderSpot';
import * as GenericBentoGrid from 'src/components/Product/GenericBentoGrid/GenericBentoGrid';
import * as GenericBentoGridItem from 'src/components/Product/GenericBentoGrid/GenericBentoGridItem';
import * as GenericBentoGridButton from 'src/components/Product/GenericBentoGrid/components/GenericBentoGridButton';
import * as GenericBentoGridSocialButtons from 'src/components/Product/GenericBentoGrid/components/GenericBentoGridSocialButtons';
import * as GenericBentoGridTextField from 'src/components/Product/GenericBentoGrid/components/GenericBentoGridTextField';
import * as IconTableSpot from 'src/components/Product/IconTableSpot/IconTableSpot';
import * as IntroSection from 'src/components/Product/IntroSection/IntroSection';
import * as introSectionTypes from 'src/components/Product/IntroSection/introSectionTypes';
import * as GenericKSPSpot from 'src/components/Product/KSP/GenericKSPSpot';
import * as GenericKSPCardsSpot from 'src/components/Product/KSP/Card/GenericKSPCardsSpot';
import * as KSPHiddenInfoSpot from 'src/components/Product/KSP/HiddenInfo/KSPHiddenInfoSpot';
import * as PlaceholderContainerContext from 'src/components/Product/KSP/Placeholder/PlaceholderContainerContext';
import * as ScrollingKSPSpot from 'src/components/Product/KSP/Scrolling/ScrollingKSPSpot';
import * as ZoomKSPSpot from 'src/components/Product/KSP/Zoom/ZoomKSPSpot';
import * as LogoSpot from 'src/components/Product/LogoSpot/LogoSpot';
import * as MediaTabs from 'src/components/Product/MediaTabs/MediaTabs';
import * as ProductFilterItem from 'src/components/Product/ProductFilterModule/ProductFilterItem';
import * as ProductFilterModuleSpot from 'src/components/Product/ProductFilterModule/ProductFilterModuleSpot';
import * as ProductFilterModuleTypes from 'src/components/Product/ProductFilterModule/ProductFilterModuleTypes';
import * as ProductFilterSidebar from 'src/components/Product/ProductFilterModule/ProductFilterSidebar';
import * as productFilterModuleUtils from 'src/components/Product/ProductFilterModule/utils/productFilterModuleUtils';
import * as ProductNotAvailableSpot from 'src/components/Product/ProductNotAvailableSpot/ProductNotAvailableSpot';
import * as ProductTopBanner from 'src/components/Product/ProductTopBanner/ProductTopBanner';
import * as RelatedProducts from 'src/components/Product/RelatedProducts/RelatedProducts';
import * as SAPromoSpot from 'src/components/Product/SAPromoSpot/SAPromoSpot';
import * as ServiceCard from 'src/components/Product/ServicesSpot/ServiceCard';
import * as ServicesSpot from 'src/components/Product/ServicesSpot/ServicesSpot';
import * as SingleImageSpot from 'src/components/Product/SingleImageSpot/SingleImageSpot';
import * as Slider from 'src/components/Product/Slider/Slider';
import * as SliderCard from 'src/components/Product/Slider/SliderCard';
import * as SoundDemo from 'src/components/Product/SoundDemo/SoundDemo';
import * as soundDemoTypes from 'src/components/Product/SoundDemo/soundDemoTypes';
import * as SoundDemoClipSwitch from 'src/components/Product/SoundDemo/components/SoundDemoClipSwitch';
import * as SoundDemoClipToggleGroup from 'src/components/Product/SoundDemo/components/SoundDemoClipToggleGroup';
import * as SoundDemoEnvironmentSelect from 'src/components/Product/SoundDemo/components/SoundDemoEnvironmentSelect';
import * as SoundDemoPlayer from 'src/components/Product/SoundDemo/components/SoundDemoPlayer';
import * as StatsSpot from 'src/components/Product/StatsSpot/StatsSpot';
import * as statsSpotTypes from 'src/components/Product/StatsSpot/statsSpotTypes';
import * as Disclaimer from 'src/components/Product/StatsSpot/components/Disclaimer';
import * as Stat from 'src/components/Product/StatsSpot/components/Stat';
import * as TechSpec from 'src/components/Product/TechSpec/TechSpec';
import * as VideoSpot from 'src/components/Product/VideoSpot/VideoSpot';
import * as CoveoUserAnalytics from 'src/components/Search/CoveoUserAnalytics';
import * as StyleGuide from 'src/components/StyleGuide/StyleGuide';
import * as StyleGuideButtons from 'src/components/StyleGuide/Buttons/StyleGuideButtons';
import * as MagicCards from 'src/components/common/MagicCards/MagicCards';
import * as ContentBlock from 'src/components/development/ContentBlock';

export const components = new Map();

components.set('PaymentMethodsBanner', PaymentMethodsBanner);
components.set('TextBanner', TextBanner);
components.set('TextSpot', TextSpot);
components.set('TopSection', TopSection);
components.set('TopWarningMessage', TopWarningMessage);
components.set('VideoBanner', VideoBanner);
components.set('CategoryPromoSlider', CategoryPromoSlider);
components.set('CategoryPromoSlides', CategoryPromoSlides);
components.set('CategoryPromoSpot', CategoryPromoSpot);
components.set('CategoryPromoSpotSliderButton', CategoryPromoSpotSliderButton);
components.set('categoryPromoSpotTypes', categoryPromoSpotTypes);
components.set('SimpleFormWrapper', SimpleFormWrapper);
components.set('IconTiles', IconTiles);
components.set('Breadcrumb', Breadcrumb);
components.set('Footer', Footer);
components.set('CondensedMenu.model', CondensedMenumodel);
components.set('CondensedMenu', CondensedMenu);
components.set('LanguageSelector', LanguageSelector);
components.set('Header', Header);
components.set('Submenu', Submenu);
components.set('types', types);
components.set('Search', Search);
components.set('LinkBlock', LinkBlock);
components.set('SustainabilitySpot', SustainabilitySpot);
components.set('ANCTypes', ANCTypes);
components.set('AccessorySpot', AccessorySpot);
components.set('SliderCardWithPrice', SliderCardWithPrice);
components.set('SliderWithPrice', SliderWithPrice);
components.set('BentoGrid', BentoGrid);
components.set('AwardsSpot', AwardsSpot);
components.set('BoxContent', BoxContent);
components.set('EcomBenefits', EcomBenefits);
components.set('FAQSpot', FAQSpot);
components.set('GlobalDealsRibbon', GlobalDealsRibbon);
components.set('HeroCustomizer', HeroCustomizer);
components.set('Hotspots', Hotspots);
components.set('KSPSpot', KSPSpot);
components.set('PillSlider', PillSlider);
components.set('SupportSpot', SupportSpot);
components.set('TopBanner', TopBanner);
components.set('CompareTableColumn', CompareTableColumn);
components.set('CompareTablesSpot', CompareTablesSpot);
components.set('compareTableSpotTypes', compareTableSpotTypes);
components.set('ContentSliderSpot', ContentSliderSpot);
components.set('CustomerStorySpot', CustomerStorySpot);
components.set('DualColumnPromoItem', DualColumnPromoItem);
components.set('DualColumnPromoSpot', DualColumnPromoSpot);
components.set('dualColumnPromoTypes', dualColumnPromoTypes);
components.set('EnterpriseBatterySpot', EnterpriseBatterySpot);
components.set('EnterpriseGenericPromoSpot', EnterpriseGenericPromoSpot);
components.set('EnterpriseImageSpot', EnterpriseImageSpot);
components.set('GallerySliderSpot', GallerySliderSpot);
components.set('GenericBentoGrid', GenericBentoGrid);
components.set('GenericBentoGridItem', GenericBentoGridItem);
components.set('GenericBentoGridButton', GenericBentoGridButton);
components.set('GenericBentoGridSocialButtons', GenericBentoGridSocialButtons);
components.set('GenericBentoGridTextField', GenericBentoGridTextField);
components.set('IconTableSpot', IconTableSpot);
components.set('IntroSection', IntroSection);
components.set('introSectionTypes', introSectionTypes);
components.set('GenericKSPSpot', GenericKSPSpot);
components.set('GenericKSPCardsSpot', GenericKSPCardsSpot);
components.set('KSPHiddenInfoSpot', KSPHiddenInfoSpot);
components.set('PlaceholderContainerContext', PlaceholderContainerContext);
components.set('ScrollingKSPSpot', ScrollingKSPSpot);
components.set('ZoomKSPSpot', ZoomKSPSpot);
components.set('LogoSpot', LogoSpot);
components.set('MediaTabs', MediaTabs);
components.set('ProductFilterItem', ProductFilterItem);
components.set('ProductFilterModuleSpot', ProductFilterModuleSpot);
components.set('ProductFilterModuleTypes', ProductFilterModuleTypes);
components.set('ProductFilterSidebar', ProductFilterSidebar);
components.set('productFilterModuleUtils', productFilterModuleUtils);
components.set('ProductNotAvailableSpot', ProductNotAvailableSpot);
components.set('ProductTopBanner', ProductTopBanner);
components.set('RelatedProducts', RelatedProducts);
components.set('SAPromoSpot', SAPromoSpot);
components.set('ServiceCard', ServiceCard);
components.set('ServicesSpot', ServicesSpot);
components.set('SingleImageSpot', SingleImageSpot);
components.set('Slider', Slider);
components.set('SliderCard', SliderCard);
components.set('SoundDemo', SoundDemo);
components.set('soundDemoTypes', soundDemoTypes);
components.set('SoundDemoClipSwitch', SoundDemoClipSwitch);
components.set('SoundDemoClipToggleGroup', SoundDemoClipToggleGroup);
components.set('SoundDemoEnvironmentSelect', SoundDemoEnvironmentSelect);
components.set('SoundDemoPlayer', SoundDemoPlayer);
components.set('StatsSpot', StatsSpot);
components.set('statsSpotTypes', statsSpotTypes);
components.set('Disclaimer', Disclaimer);
components.set('Stat', Stat);
components.set('TechSpec', TechSpec);
components.set('VideoSpot', VideoSpot);
components.set('CoveoUserAnalytics', CoveoUserAnalytics);
components.set('StyleGuide', StyleGuide);
components.set('StyleGuideButtons', StyleGuideButtons);
components.set('MagicCards', MagicCards);
components.set('ContentBlock', ContentBlock);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
